module.exports = __webpack_public_path__ + "static/media/mascot_dump.435b2234.png";